interface FormElementWrapperProps {
  children: React.ReactNode;
  display?: boolean;
}

export function FormElementWrapper({
  children,
  display = true,
}: FormElementWrapperProps) {
  return (
    <div className={`mb-5 w-full ${display ? "block" : "hidden"}`}>
      {children}
    </div>
  );
}
